import Vue from 'vue'
import App from '@/apps/App.vue'
import { bestoveRouter } from '@/router'
import store from '@/store'

import '@/apps/appConfig'

// import styles
import '@/assets/stylesheets/main--bestove.scss'

Vue.prototype.$appName = 'bestove'
Vue.prototype.$mainColor = 'danger'
Vue.prototype.$prefixUrl = '/bestove/'
Vue.prototype.$bestoveUrl = process.env.VUE_APP_BESTOVE_URL

store.$appName = 'bestove'

new Vue({
  name: 'Bestove',
  router: bestoveRouter,
  store,
  data () {
    return {
      savTitle: 'BESTOVE SAS',
      contactEmail: 'contact@bestove.fr',
      contactPhone: '01 41 95 63 10',
      contactAddress: '1-5 rue Jean Monnet',
      contactCity: '94130 Nogent sur Marne, France',
      contactLatitude: 48.8386,
      contactLongitude: 2.49336
    }
  },
  render: h => h(App)
}).$mount('#app')
